import React from 'react';
import PageMeta from 'src/components/10-atoms/seo/PageMeta';
import { useListViewModeNavbarAction } from 'src/components/20-helper-views/ListViewModeToggle';
import Page from 'src/components/templates/page/Page.template';
import PageBody from 'src/components/templates/page/PageBody.template';
import PageSearchBar from 'src/components/templates/page/PageSearchBar.template';
import { PageContentWidth } from 'src/constants/dimensions';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import useListViewMode, { isQuestionListMasterDetail } from 'src/hooks/useListViewMode';
import Analytics from 'src/lib/analytics';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { isWeb } from 'src/utils/platform';
import QuestionList from '../../containers/QuestionList';
import buildEPQuestionNavParams from '../../navigation/buildEPQuestionNavParams';
import useData from './useData';
const pageAnalytics = Analytics.event.builder().setPage('EP_QuestionSearch');
const QuestionSearch = ({ navigation, route }) => {
    const { questionID } = route.params;
    const [{ deviceType }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const { listViewMode } = useListViewMode();
    const isMasterDetail = isQuestionListMasterDetail(deviceType.isDesktop, listViewMode);
    const listViewModeNavbarAction = useListViewModeNavbarAction();
    const [state, actions] = useData();
    const buildQuestionNavParams = useCallbackWithCtx((ctx, question, index) => buildEPQuestionNavParams({
        ...(!isWeb && {
            question,
        }),
        questionID: question.id,
        navigatedFrom: 'SEARCH_QUESTIONS',
        navigationData: {
            query: ctx.state.search.deferredVal,
            sequence: index,
        },
    }), { state });
    const trackQuestionPress = useCallbackWithCtx(() => {
        pageAnalytics
            .setWidget('QuestionSearchList')
            .setTarget('Question')
            .click();
    }, []);
    const getQuestionTo = useCallbackWithCtx((ctx, question, index) => ({
        screen: 'EP_Question',
        params: ctx.buildQuestionNavParams(question, index),
    }), { buildQuestionNavParams });
    const handleSelectedQuestionIDChange = useStableCallback((nextQuestionID) => {
        navigation.setParams({ questionID: nextQuestionID });
    });
    return (React.createElement(Page, { layout: isMasterDetail
            ? { contentMaxWidth: PageContentWidth.MASTER_DETAIL }
            : undefined },
        React.createElement(PageMeta, { title: "Search COC Exam Questions", description: "Search across all COC written and oral exam questions.", canonical: "exam-prep/question-search", jsonLd: {
                '@context': 'https://schema.org',
                '@graph': [
                    {
                        '@type': 'SearchResultsPage',
                        name: 'COC Exam Question Search',
                        description: 'Search across all COC written and oral exam questions.',
                        url: 'https://marinesamraj.com/exam-prep/question-search',
                    },
                    {
                        '@type': 'WebSite',
                        name: 'MarineSamraj',
                        url: 'https://marinesamraj.com',
                        potentialAction: {
                            '@type': 'SearchAction',
                            target: 'https://marinesamraj.com/exam-prep/question-search?q={search_term_string}',
                            'query-input': 'required name=search_term_string',
                        },
                    },
                ],
            } }),
        React.createElement(PageBody, null,
            React.createElement(PageSearchBar, { value: state.search.value, onChange: actions.search.change, onClear: () => actions.search.change(''), placeholder: translate('Search for a question...'), onBackPress: navigation.goBack, actions: listViewModeNavbarAction ? [listViewModeNavbarAction] : undefined }),
            React.createElement(QuestionList, { selectedQuestionID: questionID, onSelectedQuestionIDChange: handleSelectedQuestionIDChange, variant: "question-search", queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVars, onQuestionPress: trackQuestionPress, getQuestionTo: getQuestionTo }))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default QuestionSearch;
